import { render, staticRenderFns } from "./Feedback.vue?vue&type=template&id=bb74467e&scoped=true"
import script from "./Feedback.vue?vue&type=script&lang=ts&setup=true"
export * from "./Feedback.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.18_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_n4a2vfauuuf6vmcvyn2rbj6bo4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb74467e",
  null
  
)

export default component.exports